module.exports = __webpack_public_path__ + "static/media/bed222.2089b34a.jpeg";